import cx from 'classnames';
import React from 'react';
export const TableContainer = ({ children, className, hasGroupedRows, hasHorizontalStackedList, hasStickyFirstCol, hasVerticalStackedList, ...rest }) => {
    return (React.createElement("div", { className: "tds-table-wrapper" },
        React.createElement("table", { className: cx('tds-table', {
                'tds-table--sticky-first-col': hasStickyFirstCol,
                'tds-table--grouped-row': hasGroupedRows,
                'tds-table--vertical-stacked-list': hasVerticalStackedList,
                'tds-table--horizontal-stacked-list': hasHorizontalStackedList,
            }, className), ...rest }, children)));
};
